<template>
    <div class="animated fadeIn masterGLaccount staticPageInner bgV2 pb-19">
        <b-row class="heig-frame-tab">
            <b-col md="12" class="pt-20">
                <div class="p-3 bg-white boxShadow box-shadow-none">
                    <div class="boxShadow noBorder mb-0" v-bind:class="{'run-loading':loadings.list}">
                    <div class="padding-13 heig-frame-child jobListTable">
                        <b-row class="content mt-10">
                            <b-col md="3">
                                <div class="control pull-left">
                                    <div class="list innerControl">
                                        <span  class="search" v-b-tooltip.hover title="Refresh" @click="refreshData">
                                          <img src="img/reLoad.png" alt="reload">
                                        </span>
                                        <span  class="search" v-b-tooltip.hover title="Create New" @click="modals.create = true">
                                          <img src="img/blankIcon.png" alt="ant">
                                        </span>
                                        <span v-if="selected.length" class="search" v-b-tooltip.hover title="Delete" @click="deleteData">
                                          <img src="img/deleteIcon.png" alt="delete">
                                        </span>
                                    </div>
                                </div>
                                <b-modal
                                         id="modal-Create"
                                         title="Create Mater GL Account"
                                         hide-footer :centered="true"
                                         ref="modal-createMasterGLAccount"
                                         @hidden="refreshDataObj"
                                         v-model="modals.create">
                                    <b-form class="formV2 pb-20" v-bind:class="{'run-loading':loadings.create}">
                                        <b-row>
                                            <b-col>
                                                <gofix-form-input label="Name" v-model="masterGLAccountObj.name"></gofix-form-input>
                                            </b-col>
                                        </b-row>
                                        <b-row>
                                            <b-col>
                                                <gofix-form-input label="Description" v-model="masterGLAccountObj.description"></gofix-form-input>
                                            </b-col>
                                        </b-row>
                                        <b-row>
                                            <b-col>
                                                <gofix-form-input label="Account Type" v-model="masterGLAccountObj.account_type"></gofix-form-input>
                                            </b-col>
                                        </b-row>
                                    </b-form>
                                    <b-button-group class="d-block text-right">
                                        <gofix-button label="SUBMIT" @click="createOrUpdateData" noBorder></gofix-button>
                                    </b-button-group>
                                </b-modal>
                            </b-col>
                            <b-col md="9" >
                                <div class="control">
                                    <Pagination :Items="this.Items" v-model="pages"></Pagination>
                                    <div class="list innerControl  ml-2">
                                        <span class="filter" v-on:click="filterActive" v-bind:class="[filterActive, activeClass ? 'active' : '']">
                                          <div class="tooltip">Filter</div>
                                          <svg width="21" height="13" viewBox="0 0 21 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M8.30512 13H12.7496V10.8333H8.30512V13ZM0.527344 0V2.16667H20.5273V0H0.527344ZM3.86068 7.58333H17.194V5.41667H3.86068V7.58333Z" fill="#999999"/>
                                          </svg>
                                        </span>
                                        <span class="search">
                                          <div class="tooltip">Setting</div>
                                          <b-dropdown :disabled="!$checkRole($accessModule.job_list, 'create')" class="btn btnConfig" right>
                                            <b-dropdown-item href="#">Import</b-dropdown-item>
                                            <b-dropdown-item href="#">Export</b-dropdown-item>
                                            <ColumnSetting v-model="columnActive" :nameTable="this.nameTable"></ColumnSetting>
                                          </b-dropdown>
                                        </span>
                                    </div>
                                </div>
                            </b-col>
                            <b-col md="12" class="mt-10">
                                    <b-table :fields="columnActive.show"
                                             :items="Items.data"
                                             class="table tableFilterTopRow table-filter"
                                             @row-clicked="goEdit"
                                             v-bind:class="[filterActive, activeClass ? 'open' : '']" fixed>
                                        <template slot="top-row" slot-scope="row">
                                            <FilterTable :columns="row" :search="loadDataFilter" :filter="pages.filter"></FilterTable>
                                        </template>
                                        <template slot="HEAD_actions" slot-scope="foo">
                                            <b-form-checkbox class="uniform" @input="toggleSelected" v-model="allSelected"></b-form-checkbox>
                                        </template>
                                        <template slot="id" slot-scope="row">
                                            {{ row.item.id.toString().padStart(3,0) }}
                                        </template>
                                        <template slot="actions" slot-scope="row">
                                            <b-form-checkbox :value="row.item.id" v-model="selected"></b-form-checkbox>
                                        </template>
                                    </b-table>
                            </b-col>
                        </b-row>
                    </div>
                </div>
                </div>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { filters } from '@/_filterVar.js'
    const FilterTable = () => import('../partial/FilterTableV2')
    export default {
        name: 'master-gl-account',
        components: {
            FilterTable
        },
        data() {
            return {
                activeClass: false,
                allSelected: false,
                selected: [],
                modals:{
                  create : false
                },
                loadings:{
                    list:false,
                    create:false
                },
                masterGLAccountObj:{
                    id: null,
                    name: null,
                    description: null,
                    account_type: null,
                },
                columnActive : {
                    fields: [
                        {
                            key: 'actions',
                            label: '',
                            thClass: 'checkbox-column text-center',
                            tdClass: 'checkbox-column text-center',
                            thStyle: "width:50px",
                            isActive: 1
                        },
                        {
                            key: 'id',
                            label: 'Id',
                            thStyle: "width:100px",
                            isActive: 1,
                            isFilter: true
                        },
                        {
                            key: 'name',
                            label: 'Name',
                            thStyle: "width:250px",
                            isActive: 1,
                            isFilter: true
                        },
                        {
                            key: 'description',
                            label: 'Description',
                            thStyle: "width:250px",
                            isActive: 1,
                            isFilter: true
                        },
                        {
                            key: 'account_type',
                            label: 'Account Type',
                            thStyle: "width:auto",
                            isActive: 1,
                            isFilter: true
                        }
                    ],
                    show : [],
                    hide : []
                },
                pages: {
                    isCMS: '1',
                    page: 1,
                    totalPage: 1,
                    limit: 100,
                    filter: JSON.parse(JSON.stringify(filters['master_gl_account']))
                },
                nameTable: 'tableMasterGLAccount'
            }
        },

        computed: {
            ...mapGetters({
                UserLogin: "AuthController/user",
                Items : "MasterGLAccountController/Items"
            })
        },
        async created() {
            //Load data
            this.loadData();
            //Table config column

        },
        watch: {
            "selected" : function (val) {
              if(val.length < this.Items.data.length){
                  this.allSelected = false;
              }else if(val.length === this.Items.data.length){
                  this.allSelected = true;
              }
            },
            "pages.limit": function (val) {
                if(this.pages.page === 1){
                    this.loadData();
                }else{
                    this.pages.page = 1;
                }
            },
            "pages.page": function (val) {
                this.loadData();
            },
        },
        methods: {
            loadData(){
                this.loadings.list = true;
                this.$store.dispatch("MasterGLAccountController/getItems",this.pages)
                    .then(response => {
                        this.pages.totalPage =  Math.ceil(response.total/this.pages.limit);
                        this.loadings.list = false;
                    })
                    .catch(err => {
                        this.loadings.list = false;
                    })
            },
            loadDataFilter(){
                if(this.pages.page === 1){
                    this.loadData();
                }else{
                    this.pages.page = 1;
                }

            },
            refreshData(){
                this.selected = [];
                this.allSelected = false;
                this.activeClass = false;
                this.pages.filter = JSON.parse(JSON.stringify(filters['master_gl_account']))
                if(this.pages.page === 1){
                    this.loadData();
                }else{
                    this.pages.page = 1;
                }
            },
            createOrUpdateData(){
                let action = "createItem";
                let msg = {
                    success : "Created master GL account",
                    err  : "Can't create the master GL account. Please try later!"
                };
                if(this.masterGLAccountObj.id){
                    action = "updateItem";
                    let msg = {
                        success : "Updated master GL account",
                        err  : "Can't update the master GL account. Please try later!"
                    };
                }
                this.loadings.create = true;
                this.$store.dispatch(`MasterGLAccountController/${action}`,this.masterGLAccountObj)
                    .then(response => {
                        this.loadData();
                        this.loadings.create = false;
                        this.modals.create = false;
                        this.$bvToast.toast(msg.success, {
                            title: `Notification`,
                            autoHideDelay: 3000,
                            variant: 'success',
                            solid: true
                        });
                    })
                    .catch(err => {
                        this.$bvToast.toast(msg.err, {
                            title: `Notification`,
                            autoHideDelay: 3000,
                            variant: 'error',
                            solid: true
                        });
                        this.loadings.create = false;
                    })

            },
            goEdit(item,index){
                this.masterGLAccountObj = {
                    id: item.id,
                    name: item.name,
                    description: item.description,
                    account_type: item.account_type,
                };
                this.modals.create = true;
            },
            deleteData(){
                if(this.selected.length){
                    if (confirm('Are you sure?')) {
                        this.$store.dispatch( 'MasterGLAccountController/deleteItems', this.selected).then(datas => {
                            this.$bvToast.toast(datas.data.data, {
                                title: `Notification`,
                                autoHideDelay: 3000,
                                variant: 'success',
                                solid: true
                            });
                            this.refreshData();
                        });
                    }
                }else{
                    this.$bvToast.toast("Please select the item you want to delete!", {
                        title: `Notification`,
                        autoHideDelay: 3000,
                        variant: 'error',
                        solid: true
                    });
                }
            },
            refreshDataObj(){
                this.masterGLAccountObj ={
                    id: null,
                    name: null,
                    description: null,
                    account_type: null,
                };
            },
            toggleSelected() {
                if (this.allSelected) {
                    this.selected = [];
                    for (let i in this.Items.data) {
                        this.selected.push(this.Items.data[i].id)
                    }
                    return
                }
                if (!this.allSelected && this.Items.data.length === this.selected.length) {
                    this.selected = []
                }
            },
            filterActive(){
                this.activeClass = !this.activeClass
            },

        }
    }
</script>
